import { ImgHTMLAttributes } from 'react';

import { useAuthenticatedImage } from '../../hooks/useAuthenticatedImage';
import { ImageObject } from '../../utils/getImageUrl';

interface AuthenticatedImageProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  image: File | string | ImageObject | null | undefined;
}

/**
 * Componente de imagem que faz autenticação automática
 * para carregar imagens do endpoint v3/upload/{id}/file
 */
export function AuthenticatedImage({
  image,
  alt = '',
  ...props
}: AuthenticatedImageProps) {
  const src = useAuthenticatedImage(image);

  if (!src) return null;

  return <img src={src} alt={alt} {...props} />;
}
